<!-- Copyright (C) 2023 by Posit Software, PBC. -->

<template>
  <RSModalForm
    :active="true"
    subject="Delete Execution Environment"
    @close="onClose"
    @submit="deleteEnvironment"
  >
    <template #content>
      <div
        class="details rsc-text"
      >
        <div class="rsc-alert warning">
          <p>
            Removing an environment can prevent the execution of content
            currently assigned to use that environment.
          </p>
          <p>
            Proceed only if you are comfortable with this potential effect on published content.
          </p>
        </div>
        <div class="ml-20">
          <p>
            Are you sure you want to remove the environment titled:
          </p>
          <p>
            <span class="indented-emphasis">
              {{ environment.title }}
            </span>
          </p>
          <p>
            which references the image:
          </p>
          <p>
            <span class="indented-emphasis">
              {{ environment.name }}
            </span>
          </p>
        </div>
      </div>
    </template>
    <template #controls>
      <RSButton
        id="delete-environment-dialog-submit"
        label="Delete"
        data-automation="delete-environment-dialog-submit"
      />
    </template>
  </RSModalForm>
</template>

<script>
import RSButton from '@/elements/RSButton';
import RSModalForm from '@/elements/RSModalForm';
import { CLEAR_STATUS_MESSAGE } from '@/store/modules/messages';
import { mapMutations } from 'vuex';

export default {
  name: 'EnvironmentDeleteDialog',
  components: { RSButton, RSModalForm },
  props: {
    environment: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'delete'],
  mounted() {
    this.$el.querySelector('#delete-environment-dialog-submit').focus();
  },
  methods: {
    ...mapMutations({
      clearStatusMessage: CLEAR_STATUS_MESSAGE,
    }),
    deleteEnvironment() {
      this.clearStatusMessage();
      this.$emit('delete', this.environment);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.rsc-text p {
  margin-bottom: 1rem;
}
.ml-20 {
  margin-left: 20px;
}
.indented-emphasis {
  font-weight: bold;
  padding-left: 15px;
}
</style>
